import React from 'react';
import path from 'constants/paths';
import ReportBucketIcon from 'components/atoms/icons/reportBucketIcon';
import PropTypes from 'prop-types';

const MenuItemFiles = ({ onClick }) => (
  <div className="menu-item-icon">
    <a
      href={path.bucketReport}
      target="_blank"
      className="menu-item-icon__link"
      onClick={onClick}
    >
      <div className="menu-item-icon__icon">
        <ReportBucketIcon />
      </div>
      <div className="menu-item-icon__text">Files.com.</div>
    </a>
  </div>
);

MenuItemFiles.defaultProps = {
  onClick: () => {},
};

MenuItemFiles.propTypes = {
  onClick: PropTypes.func,
};

export default MenuItemFiles;
